// Lane Auto Quotation API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LaneAutoQuotationRequests = {
    createAutomaticQuote: RequestConfigFunction<{
        data?: Record<string, any>,
    }>,
    updateImplementationDetails: RequestConfigFunction<{
        id: number,
        data?: Record<string, any>,
    }>,
    filterRequestAirlineLeaseAvailableLanes: RequestConfigFunction<Record<string, any>>,
}

const laneAutoQuotationRequests: LaneAutoQuotationRequests = {
    createAutomaticQuote: ({
        data = {},
    }) => {
        return {
            url: 'lane/automatic-quote',
            method: 'POST',
            data,
        }
    },
    updateImplementationDetails: ({
        id,
        data = {},
    }) => {
        return {
            url: `lane/${id}/implementation-details`,
            method: 'PATCH',
            data,
        }
    },
    filterRequestAirlineLeaseAvailableLanes: ({
        params = {},
    } = {}) => {
        return {
            url: 'lane/filter-request/airline-lease-available-lanes',
            method: 'POST',
            ...params,
        }
    },
}

export default laneAutoQuotationRequests
